var _a;
const DAWN_CART_TAGS = ["cart-drawer", "cart-items", "cart-drawer-items", "cart-notification"], DAWN_PUBSUB_REFRESHED_SECTIONS = /* @__PURE__ */ new Set(["cart-drawer:cart-drawer", "cart-drawer-items:CartDrawer", "cart-items:main-cart-items"]);
function collectCartSections() {
  var _a2, _b, _c;
  const sections = /* @__PURE__ */ new Map();
  for (const el of document.querySelectorAll(DAWN_CART_TAGS.join(","))) {
    let entries;
    try {
      entries = (_a2 = el.getSectionsToRender) == null ? void 0 : _a2.call(el);
    } catch (e) {
      continue;
    }
    const tag = el.tagName.toLowerCase();
    for (const entry of entries != null ? entries : []) {
      if (DAWN_PUBSUB_REFRESHED_SECTIONS.has(`${tag}:${entry.id}`)) continue;
      const sectionId = (_b = entry.section) != null ? _b : entry.id;
      if (!sectionId || sections.has(sectionId)) continue;
      const root = entry.section ? document.getElementById(entry.id) : document;
      if (!root) continue;
      const mount = entry.selector ? (_c = root.querySelector(entry.selector)) != null ? _c : entry.section ? root : null : document.getElementById(entry.id);
      mount && sections.set(sectionId, { mount, extractSelector: entry.selector || ".shopify-section" });
    }
  }
  return sections;
}
async function refreshDawnCartUI() {
  const sections = collectCartSections(), sectionsQuery = sections.size ? `?sections=${[...sections.keys()].join(",")}` : "", url = `${typeof routes < "u" && (routes == null ? void 0 : routes.cart_url) || "/cart"}.js${sectionsQuery}`, cartData = await fetch(url, { headers: { Accept: "application/json" } }).then((r) => r.ok ? r.json() : null).catch(() => null);
  if (cartData == null ? void 0 : cartData.sections) for (const [id, { mount, extractSelector }] of sections) {
    const html = cartData.sections[id];
    if (!html) continue;
    const source = new DOMParser().parseFromString(html, "text/html").querySelector(extractSelector);
    source && mount.replaceChildren(...source.childNodes);
  }
  publish(PUB_SUB_EVENTS.cartUpdate, { source: "external-refresh", cartData: cartData != null ? cartData : void 0 });
}
function initStandardActions() {
  var _a2;
  const actions = (_a2 = window.Shopify) == null ? void 0 : _a2.actions;
  actions && (actions.openCart.configure({ async handler(defaultHandler) {
    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open == "function") {
      drawer.open();
      return;
    }
    return defaultHandler();
  } }), actions.updateCart.configure({ eventTarget: () => document, async handler(defaultHandler) {
    const result = await defaultHandler();
    try {
      await refreshDawnCartUI();
    } catch (error) {
      console.error("[Dawn] Standard Actions cart refresh failed; reloading.", error), window.location.reload();
    }
    return result;
  } }));
}
((_a = window.Shopify) == null ? void 0 : _a.actions) ? initStandardActions() : document.addEventListener("DOMContentLoaded", initStandardActions, { once: true });
